var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[
			'link',
			`link-${_vm.type}`,
			_vm.underline ? 'underline' : 'no-underline'
		],attrs:{"href":_vm.path,"target":_vm.target,"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_vm._t("default"),_c('base-svg',{attrs:{"name":"link_info_icon"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }